import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const OrdersEditAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
